import partial from 'lodash/partial';
import isEmpty from 'lodash/isEmpty';
import isArray from 'lodash/isArray';
import isEqual from 'lodash/isEqual';

import { createDispatchFunction, dispatchPromise } from 'shared/helpers';
import RoomBuilderService from './RoomBuilderService';


//  Actions
const LOADING = 'rooms/LOADING';
const GET_SUCCESS = 'rooms/GET_SUCCESS';
const GET_ERROR = 'rooms/GET_ERROR';
const CREATE_SUCCESS = 'rooms/CREATE_SUCCESS';
const CREATE_ERROR = 'rooms/CREATE_ERROR';
const GET_ROOM = 'rooms/GET_ROOM';
const GET_ROOM_ALL_INFO = 'rooms/GET_ROOM_ALL_INFO';
const GET_ROOM_SUCCESS = 'rooms/GET_ROOM_SUCCESS';
const GET_ROOM_ERROR = 'rooms/GET_ROOM_ERROR';
const GET_ROOMS_SUCCESS = 'rooms/GET_ROOMS_SUCCESS';
const GET_ROOMS_ERROR = 'rooms/GET_ROOMS_ERROR';
const CREATE_ROOM = 'rooms/CREATE_ROOM';
const UPDATE_ROOM= 'rooms/UPDATE_ROOM';
const UPDATE_ROOM_TYPE_TIMING = 'rooms/UPDATE_ROOM_TYPE_TIMING';
const DELETE_ROOM = 'rooms/DELETE_ROOM';
const CLEAR_CURRENT_ROOM = 'rooms/CLEAR_CURRENT_ROOM';
const GET_PAST_EVENTS = 'rooms/GET_PAST_EVENTS';
const COPY_ROOMS = 'rooms/COPY_ROOMS';
const UPDATE_ROOM_STATUS = 'rooms/UPDATE_ROOM_STATUS';
const RESET_ERROR_ROOM = 'rooms/RESET_ERROR_ROOM';
const SUBMIT_ROOM_RANGES = 'rooms/SUBMIT_ROOM_RANGES';
const CHECK_ROOM_MISMATCH = 'rooms/CHECK_ROOM_MISMATCH';
const CLEAR_PAST_EVENTS = 'rooms/CLEAR_PAST_EVENTS';
const GET_ROOM_DTO = 'rooms/GET_ROOM_DTO';
const CHECK_ROOM_NAME_EXISTENCE = 'rooms/CHECK_ROOM_NAME_EXISTENCE';

const defaultState = {
  options: {},
  room: {},
  roomAllInfo: {},
  rooms: [],
  loadedOptions: false,
  loadingOptions: false,
  loadedPastEvents: false,
  loadingPastEvents: false,
  timerWarning: false,
  errorOptions: {},
  errorCopyRooms: false,
  errorRoom: {},
  errorPastEvents: {},
  pastEvents: [],
  errorSubmitRanges: {},
  roomNameExistent: false,
};

const name = ['capacityTypes', 'seating', 'deskTypes', 'supervisorDesk', 'shapes', 'facilities'];

const mapRoomOptions = options => options.reduce((result, item, index) => {
  /*if (name[index] === 'examTypes') {
    result[name[index]] = item.filter(elem => elem.id === 3 || elem.id === 4);
    return result;
  }*/
  result[name[index]] = item;
  return result;
}, {});

//  Reducer
export default function roomReducer(state = defaultState, action = {}) {
  switch (action.type) {
    case LOADING:
      return Object.assign({}, state, { loadedOptions: false, loadingOptions: true });
    case GET_SUCCESS:
      if (action.options) {
        action.options = mapRoomOptions(action.options);
      }
      return Object
        .assign({}, state, { loadedOptions: true, loadingOptions: false, options: action.options });
    case GET_ERROR:
      return Object
        .assign({}, state, { loadedOptions: false, loadingOptions: false, errorOptions: action.error });
    case GET_ROOM:
      if (action.result.data && state.room && state.room.id &&
        action.result.data.id !== state.room.id && !isEqual(action.result.data, state.room)) {
        return {
          ...state,
          room: {
            loading: action.result.loading ? true : undefined,
            ...action.result.data,
          },
        };
      }
      return {
        ...state,
        room: {
          ...state.room,
          loading: action.result.loading ? true : undefined,
          ...action.result.data,
        },
      };
    case GET_ROOMS_SUCCESS:
      return { ...state, rooms: action.rooms };
    case GET_ROOMS_ERROR:
      return { ...state, error: action.error };
    case CREATE_ROOM:
      return {
        ...state,
        room: action.result.data,
        errorRoom: action.result.error,
      };
    case UPDATE_ROOM:
      return {
        ...state,
        room: { ...action.result.data } || state.room,
        errorRoom: action.result.error,
      };
    case UPDATE_ROOM_TYPE_TIMING:
      return {
        ...state,
        room: action.result.data || state.room,
        errorTypeTiming: action.result.error && {error: action.result.error, status: action.result.errorStatus} ,
      };
    case RESET_ERROR_ROOM:
      return {
        ...state,
        errorRoom: {},
      };
    case UPDATE_ROOM_STATUS:
      return {
        ...state,
        room: action.result.data || state.room,
        errorUpdateStatus: action.result.error && {error: action.result.error, status: action.result.errorStatus},
      };
    case SUBMIT_ROOM_RANGES:
      return {
        ...state,
        room: action.result.data,
        errorSubmitRanges: action.result.error,
      };
    case DELETE_ROOM:
      return {
        ...state,
        loading: action.result.loading,
        error: action.result.error,
        loaded: !!action.result.data,
      };
    case CLEAR_CURRENT_ROOM:
      return {
        ...state,
        room: null,
      };
    case GET_PAST_EVENTS:
      return {
        ...state,
        loadingPastEvents: action.result.loading || false,
        loadedPastEvents: !!action.result.data || !!state.pastEvents.length ,
        errorPastEvents: action.result.error,
        pastEvents: action.result.data ? state.pastEvents.concat(action.result.data) : state.pastEvents,
        noMorePastEvents: action.result.data ? !action.result.data.length : false,
      };
    case CLEAR_PAST_EVENTS:
      return {
        ...state,
        pastEvents: [],
        loadedPastEvents: false,
      };
    case COPY_ROOMS:
      return {
        ...state,
        errorCopyRooms: !!action.result.error || (!action.result.loading && !action.result.data) ,
      };
    case CHECK_ROOM_MISMATCH:
      return {
        ...state,
      };
    case GET_ROOM_DTO:
      return {
        ...state,
        roomDTO: !isEmpty(action.result.data) ? [action.result.data] : [],
        loadingRoomsDTO: action.result.loading,
      };
    case CHECK_ROOM_NAME_EXISTENCE:
      return {
        ...state,
        roomNameExistent: action.result.data,
      };
    default: return state;
  }
}

//  Action Creators
export function getOptionsLoading() {
  return { type: LOADING };
}

export function getOptionsSuccess(options) {
  return { type: GET_SUCCESS, options };
}

export function getOptionsError(error) {
  return { type: GET_ERROR, error };
}

export function getRoomAction(result) {
  return { type: GET_ROOM, result };
}

export function getRoomsSuccess(rooms) {
  return { type: GET_ROOMS_SUCCESS, rooms };
}

export function getRoomsError(error) {
  return { type: GET_ROOMS_ERROR, error };
}

export function createRoomAction(result) {
  return { type: CREATE_ROOM, result };
}

export function updateRoomAction(result) {
  return { type: UPDATE_ROOM, result };
}

export function updateRoomTypeTimingAction(result) {
  return { type: UPDATE_ROOM_TYPE_TIMING, result };
}

export function resetErrorRoomAction() {
  return { type: RESET_ERROR_ROOM };
}

export function deleteRoomAction(result) {
  return { type: DELETE_ROOM, result };
}

export function clearCurrentRoom() {
  return { type: CLEAR_CURRENT_ROOM };
}

export function getPastEventsAction(result) {
  return { type: GET_PAST_EVENTS, result };
}
export function clearPastEventsAction() {
  return { type: CLEAR_PAST_EVENTS };
}

export function copyRoomsAction(result) {
  return { type: COPY_ROOMS, result };
}

export function updateRoomStatusAction(result) {
  return { type: UPDATE_ROOM_STATUS, result };
}

export function submitRoomRangesAction(result) {
  return { type: SUBMIT_ROOM_RANGES, result }
}

export function checkRoomMismatchAction(result) {
  return { type: CHECK_ROOM_MISMATCH, result }
}

export function getRoomDTOAction(result) {
  return { type: GET_ROOM_DTO, result };
}

export function checkRoomNameExistenceAction(result) {
  return { type: CHECK_ROOM_NAME_EXISTENCE, result }
}

//  Action dispatcher functions

export function getRoom(roomId) {
  return createDispatchFunction(
    partial(RoomBuilderService.getRoom, roomId),
    getRoomAction
  );
}

export function createRoom(room) {
  return createDispatchFunction(
    partial(RoomBuilderService.createRoom, room),
    createRoomAction
  );
}

export function updateRoom(room) {
  return createDispatchFunction(
    partial(RoomBuilderService.updateRoom, room),
    updateRoomAction,
    room,
  );
}

export function updateRoomTypeTiming(roomId, data) {
  return createDispatchFunction(
    partial(RoomBuilderService.updateRoomTypeTiming, roomId, data),
    updateRoomTypeTimingAction
  );
}

export function getRoomOptions(cycleId) {
  return function (dispatch) {
    dispatch(getOptionsLoading());
    return RoomBuilderService.getRoomOptions(cycleId)
      .then((response) => {
        dispatch(getOptionsSuccess(response));
      })
      .catch((error) => {
        dispatch(getOptionsError(error.data));
      });
  };
}

export function getRooms() {
  return function (dispatch) {
    return RoomBuilderService.getRooms()
      .then((response) => {
        dispatch(getRoomsSuccess(response));
      })
      .catch((error) => {
        dispatch(getRoomsError(error.data));
      });
  };
}

export function deleteRoom(roomId) {
  return createDispatchFunction(
    partial(RoomBuilderService.deleteRoom, roomId),
    deleteRoomAction
  );
}

export function updateRoomStatus(roomId, status) {
  return createDispatchFunction(
    partial(RoomBuilderService.updateRoomStatus, roomId, status),
    updateRoomStatusAction
  );
}

export function submitRoomRanges(roomId) {
  return createDispatchFunction(
    partial(RoomBuilderService.submitRoomRanges, roomId),
    submitRoomRangesAction
  );
}

export function getPastEvents(testCenterCycleId, eventId, params) {
  return createDispatchFunction(
    partial(RoomBuilderService.getPastEvents, testCenterCycleId, eventId, params),
    getPastEventsAction
  );
}
export function copyRooms(targetEventId, data) {
  return createDispatchFunction(
    partial(RoomBuilderService.copyRooms, targetEventId, data),
    copyRoomsAction
  );
}

export function checkRoomMismatch(room) {
  return createDispatchFunction(
    partial(RoomBuilderService.checkRoomMismatch, room),
    checkRoomMismatchAction
  );
}

export function getRoomDTO(roomId) {
  return createDispatchFunction(
    partial(RoomBuilderService.getRoomDTO, roomId),
    getRoomDTOAction
  );
}

export function checkRoomNameExistence(locEvId, roomName) {
  return createDispatchFunction(
    partial(RoomBuilderService.checkRoomNameExistence, locEvId, roomName),
    checkRoomNameExistenceAction
  );
}